const topics = [
  { tag: '新番推荐', label: '七月新番', heat: '🔥 9.8万讨论', href: '#media' },
  { tag: '国漫崛起', label: '国产精品', heat: '⭐ 7.2万关注', href: '#cards' },
  { tag: '经典重温', label: '老番补完', heat: '💬 6.5万热议', href: '#media' },
  { tag: '热血战斗', label: '燃向推荐', heat: '⚡ 8.1万讨论', href: '#ranking' },
  { tag: '恋爱喜剧', label: '甜甜番剧', heat: '💕 5.4万关注', href: '#cards' },
  { tag: '悬疑推理', label: '烧脑佳作', heat: '🧩 4.8万热议', href: '#index' },
  { tag: '异世界', label: '穿越题材', heat: '🌍 7.6万讨论', href: '#ranking' },
  { tag: '治愈日常', label: '温馨番剧', heat: '🍃 4.2万关注', href: '#media' },
  { tag: '剧场版', label: '大银幕', heat: '🎬 5.9万热议', href: '#cards' },
];

export default function SectionTopics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">热门话题</h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-8 md:mb-10">动漫圈最热的话题，都在这里讨论</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {topics.map((item, i) => (
            <a
              key={i}
              href={item.href}
              className="group flex flex-col gap-2 p-4 md:p-5 rounded-xl bg-background-100 hover:bg-primary-50 transition-all duration-200 cursor-pointer"
            >
              <span className="inline-flex items-center gap-1.5 self-start px-2.5 py-1 bg-accent-100 text-accent-700 rounded-full text-xs font-semibold">
                {item.tag}
              </span>
              <span className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">{item.label}</span>
              <span className="text-xs text-foreground-500">{item.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}